module.exports = __webpack_public_path__ + "img/chevron-contract.7e3962c1.svg";